'use client';

import { Card, CardContent } from '@repo/ui';
import { XCircle } from 'lucide-react';
import type * as React from 'react';

export function ErrorCard({ message }: { message: string }): React.ReactNode {
  return (
    <Card className="w-full max-w-sm">
      <CardContent className="flex flex-col items-center gap-3 pt-6">
        <XCircle className="size-8 text-destructive" />
        <p className="font-medium">Connection failed</p>
        <p className="text-sm text-muted-foreground text-center">{message}</p>
      </CardContent>
    </Card>
  );
}
